"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apiService_1 = __importDefault(require("@common/services/apiService"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var fromDateUtil_1 = require("@features/ItemLogPage/util/fromDateUtil");
var querryUtil_1 = require("@features/ItemLogPage/util/querryUtil");
var mediasSlice_1 = require("@features/mediaGallery/state/mediasSlice");
var ApolloErrorMessage_1 = require("@components/ApolloErrorMessage");
var icon_filter_svg_1 = __importDefault(require("@assets/icons/icon_filter.svg"));
var clsx_1 = __importDefault(require("clsx"));
var ruleSlice_1 = require("@features/Rules/state/ruleSlice");
var react_redux_1 = require("react-redux");
var dataStoring_1 = require("@/react-app/common/services/dataStoring");
var moderationQueue_1 = require("@/react-app/common/services/moderationQueue");
var moderationSetting_1 = require("@/react-app/common/services/moderationSetting");
var refusalReasons_1 = require("@/react-app/common/services/refusalReasons");
var getDecisionData_1 = require("@/react-app/common/utils/getDecisionData");
var groupBy_1 = __importDefault(require("@/react-app/common/utils/groupBy"));
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
var userSettings_1 = require("@/react-app/common/utils/userSettings");
var FilterBar_1 = __importDefault(require("./FilterBar"));
var SearchResult_1 = __importDefault(require("./SearchResult"));
var DecisionsBar_1 = __importDefault(require("./SearchResult/DecisionsBar"));
var constants_1 = require("./constants");
var store_1 = require("@/redux/store");
var FilterSideBar_1 = __importDefault(require("../Search/FilterBar/FilterSideBar"));
var Chips_1 = __importDefault(require("../Search/Chips"));
var feedbacks_1 = require("@/react-app/common/services/feedbacks");
var FilterBar_2 = require("../ItemLogPage/components/SearchBar/FilterBar");
var implioFilters_1 = require("../Search/FilterBar/FilterSideBar/implioFilters");
var utils_1 = require("../Search/FilterBar/FilterSideBar/utils");
var searchDocumentV2_1 = require("@/react-app/common/services/searchDocumentV2");
var DEFAULT_SORT = constants_1.SORTABLES[0];
var DEFAULT_PER_PAGE = {
    id: 20,
    label: 20,
};
var routeName = 'app.assignment.search';
var newRouteOpt = { notify: false, inherit: false };
function default_1(_a) {
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, currentUser = _a.currentUser;
    var _b = (0, moderationQueue_1.useGetQueuesQuery)(domain), queuesData = _b.data, queuesError = _b.error, refetchQueues = _b.refetch;
    var _c = (0, dataStoring_1.useGetDataStoringOptionQuery)(domain), storingOpt = _c.data, storingOptError = _c.error, refetchOptions = _c.refetch;
    var t = (0, react_i18next_1.useTranslation)().t;
    var minDate = (0, react_1.useMemo)(function () {
        if (storingOpt) {
            return (0, fromDateUtil_1.minDateFromPeriod)(storingOpt.period);
        }
        return null;
    }, [storingOpt]);
    var refetchData = function () {
        refetchOptions();
        refetchQueues();
    };
    if (queuesData && storingOpt && minDate && !queuesError && !storingOptError) {
        return (react_1.default.createElement(SearchSub, { domain: domain, angularJsDependencies: angularJsDependencies, minDate: minDate, currentUser: currentUser }));
    }
    return (react_1.default.createElement("div", { className: "row" },
        react_1.default.createElement("div", { className: "col-md-12" },
            react_1.default.createElement("div", { className: "empty-ng-table" },
                react_1.default.createElement(ApolloErrorMessage_1.ApolloErrorMessage, { error: queuesError || storingOptError, title: t('itemLog:TABLE.TEXT.HAS_ERROR'), refetchData: refetchData, tryAgainText: t('itemLog:TABLE.BUTTON.TRY_AGAIN') })))));
}
exports.default = default_1;
function SearchSub(_a) {
    var _b, _c, _d;
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, currentUser = _a.currentUser, minDate = _a.minDate;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, store_1.useAppDispatch)();
    var automationListsPermission = angularJsDependencies.userPermissionManager.getPermissionForOperation('automation:lists', domain);
    var moderationSettings = (0, moderationSetting_1.useGetModerationSettingOptionQuery)(domain).data;
    var refusalReasons = (0, refusalReasons_1.useGetRefusalReasonsQuery)(domain).data;
    var queuesData = (0, moderationQueue_1.useGetQueuesQuery)(domain).data;
    var feedbacks = (0, feedbacks_1.useGetFeedbacksQuery)(domain).data;
    var rules = (0, react_redux_1.useSelector)(ruleSlice_1.rulesSelector);
    // TO DO move this transformation logic in the backend api (this logic in angular is inside apiService.js file)
    var getTransFormedRefusalReasons = function (refusalReasons) {
        // const groupedByCategoryRefusalReasons = groupBy(staticRefualResult, 'categoryName');
        var groupedByCategoryRefusalReasons = (0, groupBy_1.default)(refusalReasons.results, 'categoryName');
        if (groupedByCategoryRefusalReasons && groupedByCategoryRefusalReasons.length === 1) {
            groupedByCategoryRefusalReasons[0].key = t('ITEM.DEFAULT_REFUSE_BUTTON_LABEL');
        }
        return groupedByCategoryRefusalReasons;
    };
    var transformedRefusalReasons = (refusalReasons === null || refusalReasons === void 0 ? void 0 : refusalReasons.results) && Array.isArray(refusalReasons.results) ? getTransFormedRefusalReasons(refusalReasons) : [];
    var _e = __read((0, react_1.useState)([]), 2), selectedJobRows = _e[0], setSelectedJobRows = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), isInModerationMode = _f[0], setIsInModerationMode = _f[1];
    var _g = __read((0, react_1.useState)(''), 2), decisionText = _g[0], setDecisionText = _g[1];
    var _h = __read((0, react_1.useState)({
        type: null,
    }), 2), selectedDecision = _h[0], setSelectedDecision = _h[1];
    var _j = __read(react_1.default.useState(null), 2), searchTimestamp = _j[0], setSearchTimestamp = _j[1];
    var _k = __read(react_1.default.useState(false), 2), isSubmittingLoading = _k[0], setIsSubmittingLoading = _k[1];
    var searchViewTypeLocalStorage = (0, userSettings_1.getUserSetting)("searchViewType", currentUser);
    // old searchLayout localStorage was O or 1, to prevent issue we need to check if it's 0 or 1
    var isGridView = (searchViewTypeLocalStorage === null || searchViewTypeLocalStorage === void 0 ? void 0 : searchViewTypeLocalStorage[domain]) === 'grid';
    var defaultViewType = isGridView ? 'grid' : 'list';
    var _l = __read((0, react_1.useState)(defaultViewType), 2), viewType = _l[0], setViewType = _l[1];
    var userHasPermissionToMassAction = angularJsDependencies.userPermissionManager.getPermissionForOperation('moderate:documents', domain).canWrite;
    var searchPerPageLocalStorage = (0, userSettings_1.getUserSetting)("searchPerPage", currentUser) || {};
    var searchSortingLocalStorage = (0, userSettings_1.getUserSetting)("searchSorting", currentUser) || {};
    var searchSidebarFiltersLocalStorage = (0, userSettings_1.getUserSetting)("searchSidebarFilter", currentUser) || {};
    var defaultsSearchParams = {
        perPage: ((_b = searchPerPageLocalStorage === null || searchPerPageLocalStorage === void 0 ? void 0 : searchPerPageLocalStorage[domain]) === null || _b === void 0 ? void 0 : _b.id) || DEFAULT_PER_PAGE.id,
        order: ((_c = searchSortingLocalStorage === null || searchSortingLocalStorage === void 0 ? void 0 : searchSortingLocalStorage[domain]) === null || _c === void 0 ? void 0 : _c.order) || DEFAULT_SORT.order,
        sort: ((_d = searchSortingLocalStorage === null || searchSortingLocalStorage === void 0 ? void 0 : searchSortingLocalStorage[domain]) === null || _d === void 0 ? void 0 : _d.sortBy) || DEFAULT_SORT.sortBy,
        // we always read default sidebar filters from URL params when reloading or switching teams
        // in the case of switching we read searchSidebarFilter localStorage before defining the final url to navigate (teamPicker.js)
        filters: undefined,
        from: minDate,
        to: undefined,
        domain: domain,
        currentPage: 0,
    };
    var urlParams = new URLSearchParams(window.location.search);
    // the source of truth is searchParams state object
    // searchParams take the urlParams values otherwise it takes the default values
    var _m = __read(react_1.default.useState((0, querryUtil_1.getQueryFromUrlParams)(defaultsSearchParams, urlParams, querryUtil_1.STATUSES)), 2), searchParams = _m[0], setSearchParams = _m[1];
    // console.log('searchParams', searchParams);
    var selectedSortableItem = constants_1.SORTABLES.find(function (item) { return item.sortBy === searchParams.sort && item.order === searchParams.order; }) || DEFAULT_SORT;
    var selectedPerPageItem = constants_1.PER_PAGES.find(function (item) { return item.id === searchParams.perPage; }) || DEFAULT_PER_PAGE;
    var chips = searchParams.filters
        ? (0, utils_1.tryDecodeURIComponent)(searchParams.filters)
            .split(',;,')
            .map(function (chip) {
            var _a = __read(chip.split(/:(.+)/), 2), id = _a[0], value = _a[1]; // Split only on the first colon
            return { id: id, value: (0, utils_1.tryDecodeURIComponent)(value) };
        })
        : [];
    var _o = __read(react_1.default.useState(''), 2), focusFilterId = _o[0], setFocusFilterId = _o[1];
    var _p = __read(react_1.default.useState(false), 2), isFilterSideBarOpen = _p[0], setIsFilterSideBarOpen = _p[1];
    var openFilterSideBarWithFocus = function (id) {
        setFocusFilterId(id);
        setIsFilterSideBarOpen(true);
    };
    var statuses = querryUtil_1.STATUSES.map(function (status) { return (__assign(__assign({}, status), { label: t(status.label) })); });
    var decisionResultTypes = [
        { id: 'auto', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.AUTO'), prefix: implioFilters_1.filterKey.automaticResult },
        { id: 'manual', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.MANUAL'), prefix: implioFilters_1.filterKey.manualResult },
        { id: 'remote', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.REMOTE'), prefix: implioFilters_1.filterKey.clientResult },
    ];
    var onDecisionChange = function (decision) {
        setSearchParams(__assign(__assign({}, searchParams), { type: decision, currentPage: 0 }));
    };
    var onStatusChange = function (status) {
        var statusId = status === null || status === void 0 ? void 0 : status.id;
        if (statusId && ['MANUAL', 'new'].includes(statusId)) {
            setSearchParams(__assign(__assign({}, searchParams), { status: status || undefined, currentPage: 0, type: undefined }));
        }
        else {
            setSearchParams(__assign(__assign({}, searchParams), { status: status || undefined, currentPage: 0 }));
        }
    };
    // Compute the query to send
    var queryOptions = (0, react_1.useMemo)(function () {
        if (searchTimestamp) {
            return {
                domain: domain,
                fullText: {
                    queryString: (0, querryUtil_1.queryBuilder)(searchParams, minDate || null, searchTimestamp, chips.filter(function (chip) { return chip.id !== 'text'; }), decisionResultTypes) || '',
                },
                sort: {
                    // ******** TO DO in Backend transformations *******
                    type: selectedSortableItem.sortBy === 'score' ? 'score' : 'field',
                    field: selectedSortableItem.sortBy === 'score' ? undefined : selectedSortableItem.sortBy,
                    // ******* TO DO in Backend transformations *****
                    direction: selectedSortableItem.order,
                },
                pagination: {
                    page: searchParams.currentPage || 0,
                    size: searchParams.perPage || 10,
                },
                highlight: {
                    enabled: true,
                    // preTag: '<b>',
                    // postTag: '</b>',
                },
            };
        }
    }, [searchTimestamp, minDate, searchParams, domain, chips]);
    // instead of moving the logic in child component and conditionally render it when queryOptions is undefined => we use skip
    var skip = queryOptions === undefined;
    var _q = (0, searchDocumentV2_1.useSearchDocumentsQuery)(queryOptions, {
        skip: skip,
    }), data = _q.data, error = _q.error, firstRequestLoading = _q.isLoading, isFetching = _q.isFetching, refetchDocuments = _q.refetch;
    var _r = (0, searchDocumentV2_1.useSearchDocumentsCountQuery)({
        domain: domain,
        fullText: (queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fullText) || { queryString: '' },
    }, {
        skip: skip,
    }), countData = _r.data, refetchDocumentsCount = _r.refetch;
    var refetchDocumentsAndDocumentsCount = function () {
        refetchDocuments();
        refetchDocumentsCount();
    };
    var total = (countData === null || countData === void 0 ? void 0 : countData.count) || 0;
    var transformedData = (data &&
        (0, searchDocumentV2_1.transformItemsResponseV2)(__assign({}, data), queuesData || [], searchParams.currentPage || 0, total, searchParams.perPage || DEFAULT_PER_PAGE.id)) ||
        searchDocumentV2_1.initialTransformedData;
    // Initially skip is true and we need to show the loading spinner
    var isLoading = skip || isFetching || firstRequestLoading;
    var handleViewTypeChange = function (newViewType) {
        var _a;
        if (newViewType === viewType) {
            return;
        }
        (0, userSettings_1.saveUserSetting)('searchViewType', __assign(__assign({}, searchViewTypeLocalStorage), (_a = {}, _a[domain] = newViewType, _a)), currentUser);
        setViewType(newViewType);
    };
    var toggleModerationMode = function () {
        if (isSubmittingLoading) {
            return;
        }
        if (isInModerationMode) {
            setSelectedJobRows([]);
        }
        setIsInModerationMode(!isInModerationMode);
    };
    var refreshTimestamp = function () {
        var timestamp = new Date();
        // get ads that are created 10 seconds ago, to ensure that they are probably processed and searchable
        timestamp.setSeconds(timestamp.getSeconds() - 10);
        setSearchTimestamp(timestamp.toISOString());
        setSelectedJobRows([]);
    };
    var clearCurrentImage = function () {
        transformedData.items.forEach(function (jobItem) {
            var _a;
            var adId = (_a = jobItem.ad) === null || _a === void 0 ? void 0 : _a.id;
            adId && dispatch((0, mediasSlice_1.clearImages)({ adId: adId }));
        });
    };
    var onPaginationChange = function (newPage) {
        setSelectedJobRows([]);
        clearCurrentImage();
        setSearchParams(__assign(__assign({}, searchParams), { currentPage: newPage }));
    };
    var onSortByChange = function (sortableItem) {
        var _a;
        setSelectedJobRows([]);
        clearCurrentImage();
        (0, userSettings_1.saveUserSetting)('searchSorting', __assign(__assign({}, searchSortingLocalStorage), (_a = {}, _a[domain] = {
            sortBy: sortableItem.sortBy,
            order: sortableItem.order,
        }, _a)), currentUser);
        setSearchParams(__assign(__assign({}, searchParams), { sort: sortableItem.sortBy, order: sortableItem.order, currentPage: 0 }));
    };
    var onPerPageChange = function (perPage) {
        var _a;
        setSelectedJobRows([]);
        setSearchParams(__assign(__assign({}, searchParams), { perPage: perPage.id, currentPage: 0 }));
        (0, userSettings_1.saveUserSetting)('searchPerPage', __assign(__assign({}, searchPerPageLocalStorage), (_a = {}, _a[domain] = perPage, _a)), currentUser);
    };
    var handleChipDeletion = function (id) {
        var _a;
        setSelectedJobRows([]);
        var newChips = chips.filter(function (chip) { return chip.id !== id || chip.id === 'text'; });
        var newFilters = newChips.map(function (chip) { return "".concat(chip.id, ":").concat(chip.value); }).join(',;,');
        setSearchParams(__assign(__assign({}, searchParams), { filters: newFilters }));
        (0, userSettings_1.saveUserSetting)('searchSidebarFilter', __assign(__assign({}, searchSidebarFiltersLocalStorage), (_a = {}, _a[domain] = newFilters, _a)), currentUser);
    };
    var resetSearch = function () {
        var _a;
        var text = searchParams.text, sort = searchParams.sort, order = searchParams.order, filters = searchParams.filters, rest = __rest(searchParams, ["text", "sort", "order", "filters"]);
        setSearchParams(__assign(__assign({}, rest), { text: '', currentPage: 0, sort: sort, order: order, filters: '', status: undefined, type: undefined }));
        (0, userSettings_1.saveUserSetting)('searchSidebarFilter', __assign(__assign({}, searchSidebarFiltersLocalStorage), (_a = {}, _a[domain] = undefined, _a)), currentUser);
        refreshTimestamp();
        var searchInput = document.getElementById('navSearchBox_value');
        if (searchInput != null) {
            searchInput.value = '';
        }
    };
    var handleSelectJobRow = function (jobId, checked) {
        if (checked && !selectedJobRows.includes(jobId)) {
            setSelectedJobRows(__spreadArray(__spreadArray([], __read(selectedJobRows), false), [jobId], false));
            return;
        }
        setSelectedJobRows(selectedJobRows.filter(function (row) { return row !== jobId; }));
    };
    var toggleAllCheckboxes = function (checked) {
        var jobIds = transformedData === null || transformedData === void 0 ? void 0 : transformedData.items.map(function (jobItem) { var _a; return ((_a = jobItem.ad) === null || _a === void 0 ? void 0 : _a.id) || ''; });
        checked ? setSelectedJobRows(jobIds) : setSelectedJobRows([]);
    };
    (0, react_1.useEffect)(function () {
        refreshTimestamp();
        return function () {
            clearCurrentImage();
        };
    }, []);
    (0, react_1.useEffect)(function () {
        var hasRulesPermission = angularJsDependencies.userPermissionManager.hasPermissionToEnterRoute('app.assignment.automation.filters', domain);
        if (!hasRulesPermission) {
            return;
        }
        dispatch((0, ruleSlice_1.getRules)({ domain: domain }));
    }, [domain]);
    // On every change we update the URL but not reload the page
    (0, react_1.useEffect)(function () {
        var newParams = (0, querryUtil_1.getUrlParametersFromOptions)(searchParams, defaultsSearchParams);
        angularJsDependencies.go(routeName, newParams, newRouteOpt);
    }, [searchParams]);
    var checkIsQueryEmpty = function () {
        var url = new URL(window.location.href);
        var urlSearchParams = new URLSearchParams(url.search);
        var queryParams = ['text', 'from', 'to', 'filters', 'cursor', 'status', 'type'];
        return !queryParams.find(function (queryParam) { return urlSearchParams.get(queryParam); });
    };
    var onSelectDecision = function (decision, decisionText) {
        setSelectedDecision(decision);
        setDecisionText(decisionText);
    };
    var submitDecisions = function () {
        if (!queuesData) {
            return;
        }
        var promises = [];
        setIsSubmittingLoading(true);
        transformedData === null || transformedData === void 0 ? void 0 : transformedData.items.forEach(function (item) {
            var _a;
            if (selectedJobRows.includes(((_a = item.ad) === null || _a === void 0 ? void 0 : _a.id) || '')) {
                item.setSelectedDecision(selectedDecision);
                var submitDecisionApiData = (0, getDecisionData_1.getSubmitDecisionApiData)(item);
                var promise = apiService_1.default.putDecisionForOneJob({ domain: domain, id: (submitDecisionApiData === null || submitDecisionApiData === void 0 ? void 0 : submitDecisionApiData.id) || '' }, submitDecisionApiData);
                promises.push(promise);
            }
        });
        Promise.allSettled(promises)
            .then(function (results) {
            var errors = results.filter(function (result) { return result.status === 'rejected'; });
            if (errors.length > 0) {
                var lockedAdsCount = errors.filter(function (errItem) { return errItem.reason.status === 409; }).length;
                if (lockedAdsCount === 0) {
                    notifier_1.default.display(t('SEARCH.TEXT.UPDATE_DECISION_FAILURE_OTHER_REASONS', { count: errors.length }), {
                        type: 'failure',
                        duration: 6000,
                    });
                    return;
                }
                var errorMsg = lockedAdsCount > 1
                    ? t('SEARCH.TEXT.UPDATE_DECISION_FAILURE_REACT_MANY', { count: lockedAdsCount })
                    : t('SEARCH.TEXT.UPDATE_DECISION_FAILURE_REACT_ONE');
                notifier_1.default.display(errorMsg, {
                    type: 'failure',
                    duration: 6000,
                });
            }
            else {
                var successCount = results.filter(function (result) { return result.status === 'fulfilled'; }).length;
                var successMsg = successCount > 1
                    ? t('SEARCH.TEXT.UPDATE_DECISION_SUCCESS_REACT_MANY', { count: successCount })
                    : t('SEARCH.TEXT.UPDATE_DECISION_SUCCESS_REACT_ONE');
                notifier_1.default.display(successMsg, { type: 'success', duration: 1800 });
            }
        })
            .finally(function () {
            refetchDocumentsAndDocumentsCount();
            setIsSubmittingLoading(false);
            setSelectedJobRows([]);
        });
    };
    return (react_1.default.createElement("div", { className: "job-search container", "data-ng-class": "{'submitting-decisions': vm.isSubmittingLoading}" },
        react_1.default.createElement(FilterBar_1.default, { setViewType: handleViewTypeChange, viewType: viewType, transformedData: transformedData, isLoading: isLoading, paginate: onPaginationChange, isSubmittingLoading: isSubmittingLoading, perPage: selectedPerPageItem, onPerPageChange: onPerPageChange, onSortChange: onSortByChange, sortBy: selectedSortableItem, refreshTimestamp: refreshTimestamp }),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement(Chips_1.default, { chips: chips, handleChipDeletion: handleChipDeletion, setFocusFilterId: openFilterSideBarWithFocus }))),
        react_1.default.createElement(FilterSideBar_1.default, { feedbacks: feedbacks, refusalReasons: refusalReasons, isOpen: isFilterSideBarOpen, setIsOpen: setIsFilterSideBarOpen, chips: chips, focusFilterId: focusFilterId, setFocusFilterId: setFocusFilterId, setSearchParams: setSearchParams, rules: rules, searchSidebarFiltersLocalStorage: searchSidebarFiltersLocalStorage, currentUser: currentUser, domain: domain, setSelectedJobRows: setSelectedJobRows }),
        react_1.default.createElement(FilterBar_2.ResultsFilterBar, { statusList: statuses, activeStatus: searchParams.status, onStatusChange: onStatusChange, decisionList: decisionResultTypes, activeDecision: searchParams.type, onDecisionChange: onDecisionChange }),
        react_1.default.createElement("div", { className: "end-buttons-container button-tabs-container" },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('filter-button tab', {
                    'in-moderation-mode': chips.length > 0,
                }), onClick: function () { return setIsFilterSideBarOpen(true); } },
                react_1.default.createElement("img", { src: icon_filter_svg_1.default })),
            userHasPermissionToMassAction &&
                transformedRefusalReasons &&
                transformedRefusalReasons.length > 0 &&
                (moderationSettings === null || moderationSettings === void 0 ? void 0 : moderationSettings.post_review_enabled) && (react_1.default.createElement("i", { onClick: function () { return toggleModerationMode(); }, className: (0, clsx_1.default)('implioicons-edit tab', {
                    'in-moderation-mode': isInModerationMode,
                    disabled: !transformedData.total || isSubmittingLoading || isLoading,
                }), "data-cy": "search-enter-moderation" }))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement(DecisionsBar_1.default, { loading: isLoading, items: transformedData.items, isInModerationMode: isInModerationMode, toggleAllCheckboxes: toggleAllCheckboxes, decisionText: decisionText, selectedDecision: selectedDecision, isSubmittingLoading: isSubmittingLoading, submitDecisions: submitDecisions, onSelectDecision: onSelectDecision, refusalReasons: transformedRefusalReasons || [], selectedJobRows: selectedJobRows, total: transformedData.total }))),
        react_1.default.createElement("div", { className: "row eva-search-result-row" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement(SearchResult_1.default, { isQueryEmpty: checkIsQueryEmpty(), data: transformedData, viewType: viewType, isLoading: isLoading, 
                    // TO DO check if we shood render error from rtxq or error from  transformedData
                    error: error, paginate: onPaginationChange, resetSearch: resetSearch, refetch: refetchDocumentsAndDocumentsCount, angularJsDependencies: angularJsDependencies, isInModerationMode: isInModerationMode, handleSelectJobRow: handleSelectJobRow, selectedJobRows: selectedJobRows, domain: domain, automationListsPermission: automationListsPermission })))));
}
